import $ from 'jquery'
import { toolkitUrls } from '@/links'

export { getMediumPosts, getUpcomingWebinars }

function getMediumPosts(profile) {
  var url = `${toolkitUrls.mediumPosts}/${profile}`

  return $.ajax({
    url: url,
    method: 'GET',
    dataType: 'json'
  })
}

function getUpcomingWebinars() {
  var url = `${toolkitUrls.upcomingWebinars}`
  return $.ajax({
    url: url,
    method: 'GET',
    dataType: 'json'
  })
}
